/**
 * The Technical Support slide's takeaways — see migration 136. Up to five
 * short lines, written on the review form.
 */
export const TAKEAWAY_SLOTS = 5;

export const emptyTakeaways = (): string[] => Array<string>(TAKEAWAY_SLOTS).fill('');

/** Never throws: a malformed value reads as none. Padded to five for the form. */
export function parseTakeaways(raw: string | null | undefined): string[] {
  const out = emptyTakeaways();
  if (!raw) return out;
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (Array.isArray(parsed)) {
      parsed.slice(0, TAKEAWAY_SLOTS).forEach((t, i) => {
        if (typeof t === 'string') out[i] = t;
      });
    }
  } catch {
    /* fall through to none */
  }
  return out;
}
